import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kklnyerrbehkipgylzio.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtrbG55ZXJyYmVoa2lwZ3lsemlvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE1OTQ0NDksImV4cCI6MjA3NzE3MDQ0OX0.1FFkKOSmw5y2zBlrTMs6kULvBsLrJsVHcKn_6BEl0bs';

// Create Supabase client with custom fetch to prevent response cloning issues
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    fetch: (url, options = {}) => {
      // Use native fetch and prevent any middleware from cloning the response
      return fetch(url, options);
    }
  }
});
